/**
 * dataDetailPresenter
 * --
 */

import { Content, HtmlContent } from 'components';
import { Input, Button, Descriptions, Select, Spin, Flex, Image } from 'antd';
import moment from 'moment';
import { InquirySubType } from 'constants/InquirySubType';
import { STORE_URL } from 'utils';

/**----------------------------------------
 * [Component] 총관리자: 문의상세 - Presenter
 * ----------------------------------------
 */
const InquiryDetailPresenter = ({
  FAQ,
  loading,
  reviewData,
  modalDetail,
  onChange,
  onSaveAnswer,
  onDeleteFAQ,
  FAQCategories,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Spin spinning={loading}>
      <Content
        maxWidth={'100%'}
        padding={0}
        borderRadius={4}
        style={{ marginBottom: 20 }}
      >
        {/* ===== 작성자정보 - start ===== */}
        {/* <Title size={5}>작성자정보</Title> */}
        <Descriptions
          size="small"
          bordered
          column={2}
          labelStyle={{
            width: 125,
            color: '#111',
            fontWeight: '500',
            background: '#f4f4f4',
          }}
          style={{
            borderTop: '2px solid #d1d1d1',
            borderRadius: 5,
            marginTop: 5,
          }}
          items={[
            /* === Line 1 === */
            ...(FAQ === false
              ? [
                  {
                    key: 'user_name_user_account',
                    label: '작성자',
                    children: `${modalDetail?.user?.user_name}(${modalDetail?.user?.user_account})`,
                  },
                  {
                    key: 'user_phone',
                    label: '연락처',
                    children: <span>{modalDetail?.user?.user_phone}</span>,
                  },

                  /* === Line 2 === */
                  {
                    key: 'is_secret',
                    label: '비밀글여부',
                    children: <span>{reviewData?.is_secret}</span>,
                  },
                  {
                    key: 'recipient_phone',
                    label: '작성일',
                    children: (
                      <span>
                        {moment(reviewData?.created_at * 1000).format(
                          'YYYY-MM-DD(HH:mm)'
                        )}
                      </span>
                    ),
                  },
                  /* === Line 2 === */
                  {
                    key: 'inquiry_sub_type',
                    label: '문의유형',
                    children: (
                      <span>
                        {InquirySubType[reviewData?.inquiry_sub_type]?.label}
                      </span>
                    ),
                  },
                  {
                    key: 'updated_at',
                    label: '답변일',
                    children: (
                      <span>
                        {moment(reviewData?.updated_at * 1000).format(
                          'YYYY-MM-DD(HH:mm)'
                        )}
                      </span>
                    ),
                  },
                ]
              : []),
            /* === Line 2 === */
            {
              key: 'inquiry_name',
              label: FAQ ? '유형' : '제목',
              span: 2,
              children:
                FAQ === false ? (
                  <span>{reviewData?.inquiry_name}</span>
                ) : (
                  <>
                    <Select
                      options={FAQCategories}
                      value={modalDetail?.inquiry_name}
                      onChange={(e) => onChange('inquiry_name', e)}
                      style={{ width: '100%', marginBottom: '5px' }}
                    />
                    <Input
                      value={modalDetail?.inquiry_name}
                      onChange={(e) => onChange('inquiry_name', e.target.value)}
                    ></Input>
                  </>
                ),
            },
            {
              key: 'inquiry_content',
              label: `${FAQ === false ? '문의내용' : 'FAQ 질문'}`,
              span: 2,
              children:
                FAQ === false ? (
                  <div style={{ minHeight: 140 }}>
                    <HtmlContent
                      content={reviewData?.inquiry_content}
                      style={{
                        display: 'flex',
                        padding: '5px 0px',
                        overflow: 'hidden',
                      }}
                    />
                  </div>
                ) : (
                  <Input.TextArea
                    placeholder="내용을 입력해주세요"
                    rows={8}
                    value={modalDetail?.inquiry_content}
                    onChange={(e) =>
                      onChange('inquiry_content', e.target.value)
                    }
                  ></Input.TextArea>
                ),
            },

            ...(modalDetail?.inquiry_file?.length
              ? [
                  {
                    key: 'inquiry_files',
                    label: '첨부파일',
                    span: 2,
                    children: (
                      <Flex gap={8}>
                        {modalDetail?.inquiry_file?.map((file) => (
                          <Image
                            key={`file-${file?.inquiry_file_id}`}
                            src={`${STORE_URL}/${file?.file_url}`}
                            width={80}
                            height={80}
                          />
                        ))}
                      </Flex>
                    ),
                  },
                ]
              : []),

            {
              key: 'inquiry_answer',
              label: '답변',
              span: 2,
              children: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{
                      width: '85%',
                    }}
                  >
                    <Input.TextArea
                      placeholder="내용을 입력해주세요"
                      rows={8}
                      // value={answer ?? ''}
                      // onChange={(e) => setAnswer(e.target.value)}
                      value={modalDetail?.inquiry_answer ?? ''}
                      onChange={(e) =>
                        onChange('inquiry_answer', e.target.value)
                      }
                    ></Input.TextArea>{' '}
                  </div>
                  <div
                    style={{
                      width: '14%',
                    }}
                  >
                    <Button
                      size="large"
                      block
                      style={{
                        height: '100%',
                      }}
                      onClick={onSaveAnswer}
                    >
                      저장
                    </Button>
                  </div>
                </div>
              ),
            },
          ]}
        />

        {/* ===== 작성자정보 - start ===== */}
        <div style={{ marginTop: 10 }}>
          <Button color="danger" variant="filled" onClick={onDeleteFAQ}>
            삭제
          </Button>
        </div>
      </Content>
    </Spin>
  );
};

InquiryDetailPresenter.defaultProps = {
  reviewData: null,
};
export default InquiryDetailPresenter;
